export default __webpack_public_path__ + "static/media/Metal007_1K_NormalDX.4ad43dd4.jpg";